export const root = '/'
export const home = '/'

export const binPacking = '/bin-packing'
export const calculator = '/calc'
export const costcoReceipt = '/costco'
export const planner = '/planner'
